import { gql } from '@apollo/client';
import {
  sharedInvoiceInput,
  sharedInvoiceInputFields,
} from '../../fragments/invoice-input';
import { sharedConnectionInputFields, sharedConnectionInput } from '../../fragments/connection-input';
import NoteFields from '../../fragments/invoice/note-fields';
import ReferenceFields from '../../fragments/invoice/reference-fields';
import CompanyEvaluationRestrictionMinimalFields from '../../fragments/company-evaluation-restriction/company-evaluation-restriction-minimal-fields';
import MasterEntityMinimalFields from '../../fragments/master-entity/master-entity-minimal-fields';
import InvoiceDteTypeMinimalFields from '../../fragments/invoice-dte-type/invoice-dte-type-minimal-fields';
import MoneyFields from '../../fragments/money/money-fields';
import OfferMinimalFields from '../../fragments/offer/offer-minimal-fields';
import { InvoiceReviewDocumentsFields } from '../../fragments/invoice/invoice-review-documents-fields';
import InvoiceDocumentFinanceStateFields from '../../fragments/invoice/invoice-document-finance-state-fields';

const CLIENT_OFFERS = gql`
  query clientOffers(${sharedInvoiceInputFields}, ${sharedConnectionInputFields}) {
    invoices(${sharedInvoiceInput}, ${sharedConnectionInput}) {
      totalCount
      edges {
        cursor
        node {
          id
          folio
          responsibilityType
          dateIssued
          creditNoteStatus
          isForOrdering
          dateExpiration
          isRatificated
          amountWithIva {
            ...MoneyFields
          }
          dteType {
            ...InvoiceDteTypeMinimalFields
          }
          receiver {
            ...MasterEntityMinimalFields
            invoicesActualPaymentTerm
          }
          offer {
            ...OfferMinimalFields
          }
          ...InvoiceReviewDocumentsFields
          ...InvoiceDocumentFinanceStateFields
          restrictedBy {
            ...CompanyEvaluationRestrictionMinimalFields
          }
          references {
            ...ReferenceFields
          }
          creditNotes @client {
            ...NoteFields
          }
          debitNotes @client {
            ...NoteFields
          }
        }
      }
    }
  }
  ${NoteFields}
  ${ReferenceFields}
  ${CompanyEvaluationRestrictionMinimalFields}
  ${MasterEntityMinimalFields}
  ${InvoiceDteTypeMinimalFields}
  ${MoneyFields}
  ${OfferMinimalFields}
  ${InvoiceReviewDocumentsFields}
  ${InvoiceDocumentFinanceStateFields}
`;

export default CLIENT_OFFERS;
